import { render, staticRenderFns } from "./MyBookingDetailSideCard.vue?vue&type=template&id=d1944bd0&scoped=true&"
import script from "./MyBookingDetailSideCard.vue?vue&type=script&lang=ts&"
export * from "./MyBookingDetailSideCard.vue?vue&type=script&lang=ts&"
import style0 from "./MyBookingDetailSideCard.vue?vue&type=style&index=0&id=d1944bd0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d1944bd0",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardActions } from 'vuetify/lib/components/VCard';
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VBtn,VCard,VCardActions,VSimpleTable})
